<div class="card border box-shadow-sm h-100">
	<div class="card-body p-4">
	  <div class="row align-items-center mb-3">
		<div class="col-auto">
		  <div class="avatar">
			<img [src]="image" alt="..." class="avatar-img">
		  </div>
		</div>
		<div class="col">
		  <h4 class="card-title mb-0">{{ name }}</h4>
		  <span>{{ company }}</span>
		</div>
	  </div>

	  <p class="card-text mb-0">
		<ng-content></ng-content>
	  </p>
	</div>
  </div>